import { render, staticRenderFns } from "./TravelsView.vue?vue&type=template&id=6964a7a0&"
import script from "./TravelsView.vue?vue&type=script&lang=js&"
export * from "./TravelsView.vue?vue&type=script&lang=js&"
import style0 from "./TravelsView.vue?vue&type=style&index=0&id=6964a7a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports